var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.95581 10.0001L9.41748 2.53756C9.78414 2.17173 10.3775 2.17173 10.7433 2.53756L18.2058 10.0001M3.83081 8.12506V16.5626C3.83081 17.0801 4.25081 17.5001 4.76831 17.5001H8.20581V13.4376C8.20581 12.9201 8.62581 12.5001 9.14331 12.5001H11.0183C11.5358 12.5001 11.9558 12.9201 11.9558 13.4376V17.5001H15.3933C15.9108 17.5001 16.3308 17.0801 16.3308 16.5626V8.12506M6.95581 17.5001H13.8308",
    stroke: "#2A2E34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackHome);
export default __webpack_public_path__ + "static/media/black-home.bf7cc2968ee5ae22ece455421d4bba37.svg";
export { ForwardRef as ReactComponent };